import React from "react";
import theme from "app/Theme/Theme";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const CalendarIcon = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.900"],
  ...props
}) => (
  <Svg
    width={width}
    height={height}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 24 24"
    {...props}
    fill="transparent"
  >
    <Path
      d="M8.444 3v2.7M15.556 3v2.7M4.444 9.381h15.112M20 8.85v7.65c0 2.7-1.333 4.5-4.444 4.5H8.444C5.334 21 4 19.2 4 16.5V8.85c0-2.7 1.333-4.5 4.444-4.5h7.112c3.11 0 4.444 1.8 4.444 4.5Z"
      stroke={color}
      strokeWidth={1.3}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M14.993 13.5H15m-.007 3H15m-3.003-3h.008m-.008 3h.008M9 13.5h.008M9 16.5h.008"
      stroke={color}
      strokeWidth={1.3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default CalendarIcon;
